import React from 'react';
import { SyncLoader } from 'react-spinners';

interface Props {
  isLoading?: boolean;
}

const CustomSyncLoader = ({ isLoading }: Props) => {
  if (isLoading) {
    return (
      <div className="flex items-center gap-2 px-6 py-2 bg-white border border-black rounded-full">
        <p className="text-sm">Syncing</p>
        <SyncLoader speedMultiplier={0.5} size={4} />
      </div>
    );
  }
  return <></>;
};

export default CustomSyncLoader;
